import { escapeHtml } from '../ui.js'
import { portalSideNavHtml, wirePortalSideLogout } from '../portalSideNav.js'
import { clientAckNotice, clientNotices, clientLogout } from '../api.js'
import {
  clearClientSession,
  getClientSession,
  isClientLoggedIn,
} from '../clientAuth.js'
import {
  persistPortalActiveInstallationId,
  resolvePortalActiveInstallationId,
  portalDashboardHasTwin,
} from '../portalInstallContext.js'

export function renderClientNotices() {
  return `
    <div class="dash-app">
      <aside class="dash-side">
        <p class="dash-side-label">Portal</p>
        <nav class="dash-side-nav" aria-label="Portal cliente" id="portal-side-nav">
          ${portalSideNavHtml({ activePath: '/mi-instalacion/avisos' })}
        </nav>
        <button type="button" id="dash-logout" class="portal-btn dash-side-logout">Salir</button>
      </aside>
      <div class="dash-main">
        <div class="dash-hero">
          <div>
            <p class="portal-eyebrow">Portal cliente</p>
            <h1>Avisos</h1>
            <p class="portal-muted" id="avisos-subtitle">Comunicaciones de su proveedor IT.</p>
          </div>
        </div>
        <div id="avisos-list" class="portal-card"></div>
        <p id="avisos-msg" class="portal-muted portal-form-msg" role="status"></p>
      </div>
    </div>`
}

export function bindClientNotices(root, { navigate }) {
  if (!isClientLoggedIn()) {
    navigate('/cliente', { replace: true })
    return
  }

  const session = getClientSession()
  let installationId = resolvePortalActiveInstallationId(session)
  const msg = root.querySelector('#avisos-msg')
  const list = root.querySelector('#avisos-list')

  wirePortalSideLogout(root, {
    navigate,
    onLogout: async () => {
      try {
        await clientLogout()
      } catch (_) {}
      clearClientSession()
      navigate('/', { replace: true })
    },
  })

  async function load() {
    msg.textContent = 'Cargando…'
    list.innerHTML = ''
    try {
      const data = await clientNotices(installationId)
      if (data.installation_id) {
        installationId = data.installation_id
        persistPortalActiveInstallationId(installationId)
      }
      const notices = data.notices || []
      if (notices.length === 0) {
        list.innerHTML = '<p class="portal-muted" style="padding:1rem;">No hay avisos.</p>'
      } else {
        list.innerHTML = notices
          .map(
            (n) => `
          <article class="portal-notice ${n.pending ? 'portal-notice--pending' : ''}" data-notice-id="${n.id}">
            <header>
              <strong>${escapeHtml(n.title)}</strong>
              <span class="portal-muted">${escapeHtml(n.notice_number || '')}</span>
            </header>
            <p style="white-space:pre-wrap;margin:0.5rem 0;">${escapeHtml(n.body)}</p>
            <footer class="portal-notice-foot">
              <span class="portal-muted">${escapeHtml(n.status_label || n.status)}</span>
              ${
                n.pending
                  ? `<button type="button" class="portal-btn portal-btn-primary portal-btn-sm" data-ack="${n.id}">Marcar como leído</button>`
                  : ''
              }
            </footer>
          </article>`
          )
          .join('')
      }
      msg.textContent = data.pending_count
        ? `${data.pending_count} aviso(s) pendiente(s) de confirmar.`
        : ''
      list.querySelectorAll('[data-ack]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          const id = btn.getAttribute('data-ack')
          btn.disabled = true
          try {
            await clientAckNotice(id, installationId)
            await load()
          } catch (e) {
            msg.textContent = e.message || 'Error al confirmar.'
            btn.disabled = false
          }
        })
      })
    } catch (e) {
      msg.textContent = e.message || 'No se pudieron cargar los avisos.'
    }
  }

  load()
}
